import React, { useId, useState } from 'react'
import { Link } from 'react-router'
import {useMediaQuery} from '@react-hook/media-query'
import $ from 'jquery';

import logo from './images/logo-eliana-consulting.svg'
import serveurs from './images/serveurs.jpg'
import rightArrow from './images/right-arrow.svg'
import convention from './images/convention.jpg'
import experts2 from './images/experts-2.jpg'
import tours from './images/tours.jpg'

import './App.css'
import './App.scss'

$(document).on('scroll', function(){
  if ( $(window).scrollTop() > 30) {
    console.log("Tu es descendu dans la page!");
    $('header').addClass('change-color');
  } else {
    console.log("Tu es remonté en haut.")
    $('header').removeClass('change-color');
  }
});

const MobileVersion = (props) => {
  const id = useId();

  const [inputName, setInputName] = useState(props?.value ?? '');
  const [inputSurname, setInputSurname] = useState(props?.value ?? '');
  const [inputCompany, setInputCompany] = useState(props?.value ?? '');
  const [inputEmail, setInputEmail] = useState(props?.value ?? '');
  const [inputPrefix, setInputPrefix] = useState(props?.value ?? '+33');
  const [inputTel, setInputTel] = useState(props?.value ?? '');
  const [inputMessage, setInputMessage] = useState(props?.value ?? '');
  const [reponse, setReponse] = useState(props?.value ?? '');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (inputName == '' || inputSurname == '' || inputEmail == '' || inputMessage == ''){
      setReponse("Les champs n'ont pas été complétés.");
      return;
    } else {
      setReponse("Envoi du message...");

      const data = {
        name: inputName,
        surname: inputSurname,
        company: inputCompany,
        email: inputEmail,
        prefix: inputPrefix,
        tel: inputTel,
        message: inputMessage
      } 

      try {
        const response = await fetch('./contact.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        });

        if (response.ok) {
          setReponse("Merci! Votre message à bien été envoyé. Nous vous répondrons au plus vite.");
        } else {
          setReponse("Le message n'a pas pu être envoyé.");
          console.log(response);
        }
      } catch (error) {
        console.error('Error:', error);
      }
    }
  };

  return (
    <>
      <header>
        <a href="./">
          <img src={logo} className="logo" alt="logo" />
        </a>
        <a href="#contact"><button>CONTACT</button></a>
      </header>
      <div className="hero">
        <h1>Nous vous mettons en relation avec les experts.</h1>
        <p>
          Optimisez vos systèmes d’information.<br/>
          Simplifiez vos décisions.<br/>
          Accélérez votre croissance.
        </p>
      </div>
      <div className="proposition">
        <h2>
          Une expertise <br/>
          globale, <br/>
          fiable<br/>
          et prouvée.
        </h2>

        <p>Un réseau de partenaires au service de votre performance.</p>

        <span className="premierNombre">100+</span>
        <span className="premierTexte">Entreprises accompagnées</span>
        <span className="deuxiemeNombre">50+</span>
        <span className="deuxiemeTexte">Partenaires IT qualifiés</span>
        <span className="troisiemeNombre">20+</span>
        <span className="troisiemeTexte">Secteurs d’activités couverts</span>
        <span className="dernierNombre">100%</span>
        <span className="dernierTexte">adapté à vos besoins.</span>

        <img src={serveurs} />
      </div>
      <div className="prestations">
        <h2>Nos prestations</h2>

        <div className="premierePrestation">
          <div className="leftSection">
            <div className="numberBox">
              1
            </div>
          </div>
          <div className="middleSection">
            <h3>Optimisation & gestion IT</h3>
            <p>
              Nous optimisons et pilotons votre infrastructure informatique pour garantir performance, sécurité et simplicité au quotidien.
            </p>
          </div>
          <div className="rightSection">
            <div className="buttonBox">
              <img src={rightArrow} />
            </div>
          </div>
        </div>

        <div className="deuxiemePrestation">
          <div className="leftSection">
            <div className="numberBox">
              2
            </div>
          </div>
          <div className="middleSection">
            <h3>Transformation numérique</h3>
            <p>
              Nous accompagnons votre transition numérique avec des solutions adaptées pour moderniser vos outils, optimiser vos processus et soutenir votre croissance.
            </p>
          </div>
          <div className="rightSection">
            <div className="buttonBox">
              <img src={rightArrow} />
            </div>
          </div>
        </div>

        <div className="troisiemePrestation">
          <div className="leftSection">
            <div className="numberBox">
              3
            </div>
          </div>
          <div className="middleSection">
            <h3>Solutions matérielles & logicielles</h3>
            <p>
              Nous vous aidons à choisir et déployer des solutions informatiques adaptées à vos besoins pour garantir performance, fiabilité et évolutivité.
            </p>
          </div>
          <div className="rightSection">
            <div className="buttonBox">
              <img src={rightArrow} />
            </div>
          </div>
        </div>

        <div className="quatriemePrestation">
          <div className="leftSection">
            <div className="numberBox">
              4
            </div>
          </div>
          <div className="middleSection">
            <h3>Mise en relation avec des experts</h3>
            <p>
              Nous vous connectons aux partenaires et spécialistes les plus adaptés à vos besoins pour garantir des solutions fiables et performantes.
            </p>
          </div>
          <div className="rightSection">
            <div className="buttonBox">
              <img src={rightArrow} />
            </div>
          </div>
        </div>
      </div>
      <div id="contact" className="contact">
        <img src={convention} />
        <h2>Contactez-nous</h2>
        <p>Parlez nous de votre projet...</p>
        <form id="contact" onSubmit={handleSubmit}>
          <label>Prénom*</label>
          <input type="text" name="name" id={id} value={inputName} onChange={e => setInputName(e.target.value)} required></input>
          <label for>Nom*</label>
          <input type="text" name="surname" id={id} value={inputSurname} onChange={e => setInputSurname(e.target.value)} required></input>
          <label for="company">Société</label>
          <input type="text" name="company" id={id} value={inputCompany} onChange={e => setInputCompany(e.target.value)}></input>
          <label for="email">Email*</label>
          <input type="email" name="email" className="email" id={id} value={inputEmail} onChange={e => setInputEmail(e.target.value)} required></input>
          <label for="tel">Téléphone</label>
          <input type="text" name="prefix" className="prefix" id={id} value={inputPrefix} onChange={e => setInputPrefix(e.target.value)}></input>
          <input type="tel" name="tel" className="tel" id={id} value={inputTel} onChange={e => setInputTel(e.target.value)}></input>
          <label for="message">Votre message*</label>
          <textarea type="text" name="message" id={id} value={inputMessage} onChange={e => setInputMessage(e.target.value)} rows="5" required></textarea>
          <input type="submit" id="submit-form" value="Envoyer" className="submitButton" />
        </form>
        <p className="formResponse">{reponse}</p>
      </div>
      <footer>
        <div className="topSection">
          <div className="horaires">
            <h4>Horaires</h4>
            <span>Du lundi au vendredi</span><br/>
            <span>10h00 à 18h00</span>
          </div>
          
          <div className="nousContacter">
            <h4>Nous contacter</h4>
            <a href="mailto:contact@eliana-consulting.com" className="mail">contact@eliana-consulting.com</a>
            <a href="tel:+33649069059" className="tel">+33 6 49 06 90 59</a>
          </div>
          
          <div className="links">
            <Link to="/mentions-legales">Mentions Légales</Link>
            {/*<a href="">FAQ</a>*/}
          </div>
        </div>
        <hr />
        <div className="bottomSection">
          <div className="leftSection">
            © 2026 Eliana Consulting.<br/>
            Tous droits réservés.
          </div>
          <div className="rightSection">
            <a href="./">
              <img src={logo} />
            </a>
          </div>
        </div>
      </footer>
    </>
  );
}

const DesktopVersion = (props) => {
  const id = useId();

  const [inputName, setInputName] = useState(props?.value ?? '');
  const [inputSurname, setInputSurname] = useState(props?.value ?? '');
  const [inputCompany, setInputCompany] = useState(props?.value ?? '');
  const [inputEmail, setInputEmail] = useState(props?.value ?? '');
  const [inputPrefix, setInputPrefix] = useState(props?.value ?? '+33');
  const [inputTel, setInputTel] = useState(props?.value ?? '');
  const [inputMessage, setInputMessage] = useState(props?.value ?? '');
  const [reponse, setReponse] = useState(props?.value ?? '');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (inputName == '' || inputSurname == '' || inputEmail == '' || inputMessage == ''){
      setReponse("Les champs n'ont pas été complétés.");
      return;
    } else {
      setReponse("Envoi du message...");

      const data = {
        name: inputName,
        surname: inputSurname,
        company: inputCompany,
        email: inputEmail,
        prefix: inputPrefix,
        tel: inputTel,
        message: inputMessage
      } 

      try {
        const response = await fetch('./contact.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        });

        if (response.ok) {
          setReponse("Merci! Votre message à bien été envoyé. Nous vous répondrons au plus vite.");
        } else {
          setReponse("Le message n'a pas pu être envoyé.");
          console.log(response);
        }
      } catch (error) {
        console.error('Error:', error);
      }
    }
  };

  return (
    <>
      <header>
        <a href="./">
          <img src={logo} className="logo" alt="logo" />
        </a>
        <a href="#contact"><button>CONTACT</button></a>
      </header>
      <div className="hero">
        <h1>Nous vous mettons <br />en relation avec les experts.</h1>
        <p>
          Optimisez vos systèmes d’information.<br/>
          Simplifiez vos décisions.<br/>
          Accélérez votre croissance.
        </p>
      </div>
      <div className="proposition">
        <h2>
          Une expertise globale, <br/>
          fiable et prouvée.
        </h2>
        <p>
          Un réseau de partenaires au <br />
          service de votre performance.
        </p>

        <div className="avantages">
          <div className="leftSection">
            <span className="premierNombre">100+</span>
            <span className="premierTexte">Entreprises accompagnées</span>
          </div>
          <div className="middleSection">
            <span className="deuxiemeNombre">50+</span>
            <span className="deuxiemeTexte">Partenaires IT qualifiés</span>
          </div>
          <div className="rightSection">
            <span className="troisiemeNombre">20+</span>
            <span className="troisiemeTexte">Secteurs d’activités couverts</span>
          </div>
        </div>

        <div className="conclusion">
          <div className="leftSection">
            <span className="dernierNombre">100%</span>
            <span className="dernierTexte">adapté à vos besoins.</span>
          </div>
          <div className="rightSection">
            <img src={serveurs} />
          </div>
        </div>
      </div>
      <div className="prestations">
        <h2>Nos prestations</h2>

        <div className="flexBox">
          <div className="leftSection">
            <div className="imgBox">
              <img src={experts2} />
            </div>
          </div>
          <div className="rightSection">
            <div className="premierePrestation">
              <div className="leftSection">
                <div className="numberBox">
                  1
                </div>
              </div>
              <div className="rightSection">
                <h3>Optimisation & gestion IT</h3>
                <p>
                  Nous optimisons et pilotons votre infrastructure informatique pour garantir performance, sécurité et simplicité au quotidien.
                </p>
              </div>
            </div>

            <div className="deuxiemePrestation">
              <div className="leftSection">
                <div className="numberBox">
                  2
                </div>
              </div>
              <div className="rightSection">
                <h3>Transformation numérique</h3>
                <p>
                  Nous accompagnons votre transition numérique avec des solutions adaptées pour moderniser vos outils, optimiser vos processus et soutenir votre croissance.
                </p>
              </div>
            </div>

            <div className="troisiemePrestation">
              <div className="leftSection">
                <div className="numberBox">
                  3
                </div>
              </div>
              <div className="rightSection">
                <h3>Solutions matérielles & logicielles</h3>
                <p>
                  Nous vous aidons à choisir et déployer des solutions informatiques adaptées à vos besoins pour garantir performance, fiabilité et évolutivité.
                </p>
              </div>
            </div>

            <div className="quatriemePrestation">
              <div className="leftSection">
                <div className="numberBox">
                  4
                </div>
              </div>
              <div className="rightSection">
                <h3>Mise en relation avec des experts</h3>
                <p>
                  Nous vous connectons aux partenaires et spécialistes les plus adaptés à vos besoins pour garantir des solutions fiables et performantes.
                </p>
              </div>
            </div>
          </div>
        </div>

        
      </div>
      <div id="contact" className="contact">
        <div className="imgBox">
          <img src={tours} />
        </div>
        
        <h2>Contactez-nous</h2>
        <p>Parlez nous de votre projet...</p>
        <form id="contact" onSubmit={handleSubmit}>
          <div className="topSection">
            <div className="leftSection">
              <label>Prénom*</label>
              <input type="text" name="name" id={id} value={inputName} onChange={e => setInputName(e.target.value)} required></input>
              <label for>Nom*</label>
              <input type="text" name="surname" id={id} value={inputSurname} onChange={e => setInputSurname(e.target.value)} required></input>
              <label for="company">Société</label>
              <input type="text" name="company" id={id} value={inputCompany} onChange={e => setInputCompany(e.target.value)}></input>
              <label for="email">Email*</label>
              <input type="email" name="email" className="email" id={id} value={inputEmail}  onChange={e => setInputEmail(e.target.value)} required></input>
              <label for="tel">Téléphone</label>
              <input type="text" name="prefix" className="prefix" id={id} value={inputPrefix} onChange={e => setInputPrefix(e.target.value)}></input>
              <input type="tel" name="tel" className="tel" id={id} value={inputTel} onChange={e => setInputTel(e.target.value)}></input>
            </div>
            <div className="rightSection">
              <label for="message">Votre message*</label>
              <textarea type="text" name="message" id={id} value={inputMessage} onChange={e => setInputMessage(e.target.value)} rows="8" required></textarea>
            </div>
          </div>
          <div className="bottomSection">
            <input type="submit" id="submit-form" value="Envoyer" className="submitButton" />
          </div>
        </form>
        <p className="formResponse">{reponse}</p>
      </div>
      <footer>
        <div className="leftSection">
          <img src={logo} />
          <p>
            © 2026 Eliana Consulting.<br/>
            Tous droits réservés.
          </p>
        </div>
        <div className="footerVerticalLine"></div>
        <div className="rightSection">
          <div className="infos">
            <h4>Horaires</h4>
            <p>Du lundi au vendredi <br/>
            10h00 à 18h00</p>
            
            <h4>Nous contacter</h4>
            <a href="mailto:contact@eliana-consulting.com">contact@eliana-consulting.com</a>
            <a href="tel:+33649069059">+33 6 49 06 90 59</a>
          </div>
          <div className="links">
            <Link to="/mentions-legales">Mentions Légales</Link>
            {/*<a href="">FAQ</a>*/}
          </div>
        </div>
      </footer>
    </>
  );
}

function App() {
  const matches = useMediaQuery('only screen and (min-width: 577px)');

  return (
    !matches ?
      <MobileVersion />
    :
      <DesktopVersion />
  )
}

export default App